const endpoint = {
  user: "user/",
  login: "login/",
  signup: "signup/",
  authenticate: "authenticate",
  refund: "ecom/refund/apply",
  getEcomRefunds: "getEcomPendingStatusList",
  cancel: "cancel",
  getBalance: "getBalance",
  getPOSBalance: "getBalancePos",
  forgotPassword: "forgetPasswordRequest",
  forgetPassword: "forgetPassword",
  changePassword: "changePassword",
  getPOSTransactions: "getTransactionFilterPos",
  getPOSTransactionsWStates: "getTransactionFilterWithStatePos",
  getMerchantTIDs: "getMerchantActiveTids",
  getTransactionLogList: "getTransactionLogList",
  getTransactionSearch: "getTransactionSearch",
  getTransactionOverview: "getTransactionOverview",
  getTransactionOverviewSearch: "getTransactionOverviewSearch",
  getTransactionMPGS: "getTransactionMPGS",
  getTransactionUPI: "getTransactionUPI",
  getTransactionPayPak: "getTransactionPAYPAK",
  getPOSDetailsUPI: "getTransactionDetailPosUpi",
  getPOSDetailsVisa: "getTransactionDetailPosVisa",
  getPOSDetailsMastercard: "getTransactionDetailPosMastercard",
  getPOSDetailsPaypak: "getTransactionDetailPosPaypak",
  getTransactionFilterPos: "getTransactionFilterPos",
  getViewInquiryTransaction: "getViewInquiryTransaction",
  posRefund: "pos/refund/apply",
  posReturnedRefunds: "pos/refund/makerReturnedPending",
  getBalanceFilterPos: "getBalanceFilterPos",
  generateFedReport: "generateFedReport",
  logout: "logout",
  account: "account/",
  getCampaignDetails: 'discount-campaign/merchant-campaign-details',

  fbl: {
    sqrcGenerateQr: "sqrc",
    getTotalAmount: "getTotalAmount",
    getMerchantDetails: 'merchant-details',
    getAllRaastThirdParty: "thirdParty/getAllRaastThirdParty",
    generateExcelFile: "export/excel/file",
  }
};

const loginEndpoints = {
  login: "login",
  setup: "setup2fa",
  validate: "validate2fa",
};

const config = {
  captcha: window?.config?.recaptcha?.captcha, // FOR TESTING
  appSettings: {
    showAllLogs: window.config.appSettings.showAllLogs,
  },
  url: {
    login: {
      ...loginEndpoints,
      baseURL: window.config.baseUrl,
    },
    authenticate: window.config.url.authenticate,
    account: window.config.url.account,
    transaction: window.config.url.transaction,
    register: window.config.url.register,
    qr: window.config.url.qr,
    campaign: window.config.url.campaign,
  },
  method: {
    register: "register",
  },
  endpoint,
  acquirer: window.config.acquirer || "tapsys",
};

// const config = process.env.NODE_ENV === "production" ? development : development;

export default config;
